module.exports = __webpack_public_path__ + "static/media/no_connection.7ebb5f3f.svg";